import appConfig from '@config/appConfig.json';
const mainConfig = Object.assign({}, appConfig);
export default mainConfig;
